export class CustomError extends Error {
  constructor(
    message: string,
    private status: number = 500
  ) {
    super(message);
  }
}
